export default __webpack_public_path__ + "static/media/footer.af35a53c.png";